import PublicNav from '@/components/public/PublicNav';
import PublicFooter from '@/components/public/PublicFooter';
import { useReveal } from '@/hooks/useReveal';
import { useLang } from '@/i18n/LanguageContext';
import { PageMeta } from '@/components/PageMeta';

const f = "'IBM Plex Mono', monospace";

export default function PrivacidadePage() {
  const { t } = useLang();
  const rTitle = useReveal(100);
  const rHighlight = useReveal(200);
  const reveals = [useReveal(200), useReveal(300), useReveal(400), useReveal(500), useReveal(600)];

  const tBlocks = t('privacidade.blocks') as Array<{ label: string; text: string }>;
  const blocks = tBlocks.map((b, i) => ({ ...b, reveal: reveals[i] }));

  return (
    <>
      <PublicNav />
      <PageMeta title={t('privacidade.docTitle') as string} description={t('privacidade.metaDesc') as string} />
      <main style={{ background: 'var(--lp-bg)', minHeight: '100vh', fontFamily: f, color: 'var(--lp-ink)' }}>
        <section
          className="lp-section"
          style={{ display: 'grid', gridTemplateColumns: '200px 1fr', borderTop: '0.5px solid var(--lp-border)' }}
        >
          <div
            className="lp-section-label split-label"
            style={{ borderRight: '0.5px solid var(--lp-border)', position: 'sticky', top: 72, alignSelf: 'start' }}
          >
            <div style={{ fontSize: 'var(--type-label)', letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--lp-muted)' }}>
              <div>004</div>
              <div style={{ marginTop: 4 }}>{t('privacidade.label')}</div>
            </div>
          </div>
          <div className="split-content">
            <div ref={rTitle.ref} style={rTitle.style}>
              <h1 style={{ fontSize: 'var(--type-h1)', fontWeight: 300, marginBottom: '3rem' }}>{t('privacidade.title')}</h1>
            </div>

            <div ref={rHighlight.ref} style={rHighlight.style}>
              <p style={{
                fontSize: 'var(--type-h2)', fontWeight: 300, lineHeight: 1.8,
                color: 'var(--lp-ink)', marginBottom: '3rem', maxWidth: 540, whiteSpace: 'pre-line',
              }}>
                {t('privacidade.highlight')}
              </p>
            </div>

            {blocks.map((block) => (
              <div key={block.label} ref={block.reveal.ref} style={{ ...block.reveal.style, borderTop: '0.5px solid var(--lp-border)', padding: '2rem 0' }}>
                <div style={{ fontSize: 'var(--type-label)', textTransform: 'uppercase', letterSpacing: '0.14em', color: 'var(--lp-muted)', marginBottom: '0.75rem' }}>
                  {block.label}
                </div>
                <p style={{ fontSize: 'var(--type-body)', lineHeight: 1.9, color: 'var(--lp-muted)', maxWidth: 500 }}>
                  {block.text}
                </p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <PublicFooter />
    </>
  );
}
